<template>
    <div>
        <div
            style="position: -webkit-sticky; position: sticky; top: 48px; background-color:white; z-index:1;"
        >
            <v-container class="pa-0" fluid>
                <v-row no-gutters align="center">
                    <v-col cols="6">
                        <v-text-field
                            class="mr-5"
                            v-model.trim="searchQuery"
                            label="Szukaj"
                            prepend-inner-icon="mdi-magnify"
                            maxlength="100"
                            clearable
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageFirst" @click="prevPage">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </template>
                            <span>Poprzednia strona</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageLast" @click="nextPage">
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </template>
                            <span>Następna strona</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
            <hr class="mb-1">
        </div>

        <loading-message v-if="colorIndexing" :message="loadingMessage" class="my-5"></loading-message>
        <v-simple-table v-else-if="colors.length" style="table-layout: auto">
            <template v-slot:default>
                <tbody>
                <tr
                    v-for="clr in colors"
                    :key="clr.UnitColorID"
                    :style="{ color: clr.Archived ? 'lightgrey' : 'inherit' }"
                >
                    <th class="text-no-wrap" style="width: 100%">
                        {{ clr.UnitColorName }}
                    </th>
                    <td class="text-center text-no-wrap">
                        <img
                            v-if="clr.UnitColorImage"
                            :src="clr.UnitColorImage"
                            :alt="clr.UnitColorName"
                            class="my-1"
                            style="width: 50px; height: 50px; vertical-align: middle;"
                            :style="{ opacity: clr.Archived ? 0.3 : 1 }"
                        />
                        <span v-else class="font-italic">- brak zdjęcia -</span>
                    </td>
                    <td class="text-right">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="clr.UnitColorImage" v-bind="attrs" v-on="on" icon @click="showColorImageDeleteDialog(clr)">
                                    <v-icon
                                        :style="{ color: clr.Archived ? 'lightgrey' : 'inherit' }"
                                    >
                                        mdi-trash-can-outline
                                    </v-icon>
                                </v-btn>
                                <v-btn v-else v-bind="attrs" v-on="on" icon @click="showColorImageStoreDialog(clr)">
                                    <v-icon
                                        :style="{ color: clr.Archived ? 'lightgrey' : 'inherit' }"
                                    >
                                        mdi-plus-circle-outline
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span v-if="clr.UnitColorImage">Usuń zdjęcie</span>
                            <span v-else>Dodaj zdjęcie</span>
                        </v-tooltip>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ emptyMessage }}</v-alert>

        <v-dialog
            v-model="colorImageStoreDialog"
            persistent
            width="500"
        >
            <v-card v-if="colorToStoreColorImage">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Zdjęcie koloru {{colorToStoreColorImage.UnitColorName}}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideColorImageStoreDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="colorImageForm.ColorImage"
                        label="Zdjęcie koloru"
                        hint="Dozwolone formaty: jpg, png, tif. Maksymalny rozmiar: 5Mb."
                        persistent-hint
                        prepend-icon="mdi-camera"
                        :error="$store.getters.hasValidationError('ColorImage')"
                        :error-messages="$store.getters.validationError('ColorImage')"
                    ></v-file-input>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="colorImageStore"
                        :loading="colorImageStoring"
                    >Dodaj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="colorImageDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="colorToDeleteColorImage">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuwanie zdjęcia
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideColorImageDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    Czy na pewno chcesz usunąć zdjęcie koloru
                    <strong>{{colorToDeleteColorImage.UnitColorName}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="colorImageDelete(colorToDeleteColorImage)"
                        :loading="colorImageDeleting"
                    >Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";

export default {
    name: "Colors",
    components: {
        LoadingMessage,
    },
    data() {
        return {
            searchQuery: "",

            colorIndexing: false,
            colors: [],

            colorImageStoreDialog: false,
            colorToStoreColorImage: null,
            colorImageStoring: false,

            colorImageDeleteDialog: false,
            colorToDeleteColorImage: null,
            colorImageDeleting: false,

            colorImageForm: {
                ColorImage: null,
            },

            // pagination
            page: 1,
            lastPage:1,
            from: 0,
            to: 0,
            total: 0,
        };
    },
    computed: {
        isPageFirst() {
            return this.page === 1;
        },

        isPageLast() {
            return this.page === this.lastPage;
        },

        loadingMessage() {
            return !this.searchQuery
                ? "Pobieranie listy kolorów..."
                : "Wyszukiwanie kolorów...";
        },

        emptyMessage() {
            return !this.searchQuery
                ? "Brak kolorów"
                : "Nie znaleziono kolorów pasujących do podanej frazy";
        },
    },
    methods: {
        loadPage() {
            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.color_index) {
                this.$store.state.sources.color_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedColorIndexFast();
        },
        nextPage: function () {
            if (this.page < this.lastPage) {
                this.page++;
                this.loadPage();
            }
        },
        prevPage: function () {
            if (this.page > 1) {
                this.page--;
                this.loadPage();
            }
        },
        resetPage () {
            this.page = 1;
        },
        colorIndex () {
            this.colorIndexing = true;

            this.$store.dispatch('colorIndex', {
                page: this.page,
                searchQuery: this.searchQuery,
            }).then(response => {
                if(response.status === 200) {
                    this.colors = response.data.data;
                    this.page = response.data.meta.current_page ?? 1;
                    this.lastPage = response.data.meta.last_page ?? 1;
                    this.from = response.data.meta.from ?? 0;
                    this.to = response.data.meta.to ?? 0;
                    this.total = response.data.meta.total;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy kolorów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.colorIndexing = false;
                });
        },
        colorImageStore: function () {
            this.colorImageStoring = true;

            this.$store.dispatch('colorImageStore', {
                UnitColorID: this.colorToStoreColorImage.UnitColorID,
                formData: this.colorImageForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideColorImageStoreDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano zdjęcie.");
                    this.colorIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.colorImageStoring = false;
                });
        },
        colorImageDelete: function (clr) {
            this.colorImageDeleting = true;

            this.$store.dispatch('colorImageDelete', clr.UnitColorID).then(response => {
                if (response.status === 204) {
                    this.hideColorImageDeleteDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto zdjęcie.");
                    this.colorIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.colorImageDeleting = false;
                });
        },
        showColorImageStoreDialog: function (clr) {
            this.colorToStoreColorImage = clr;
        },
        hideColorImageStoreDialog: function () {
            this.colorImageStoreDialog = false;
        },
        showColorImageDeleteDialog: function (clr) {
            this.colorToDeleteColorImage = clr;
        },
        hideColorImageDeleteDialog: function () {
            this.colorImageDeleteDialog = false;
        },
        resetColorImageForm: function () {
            for (const index in this.colorImageForm) {
                this.colorImageForm[index] = null;
            }
        },
    },
    created() {
        this.debouncedColorIndex = _.debounce(this.colorIndex, 900);
        this.debouncedColorIndexFast = _.debounce(this.colorIndex, 300);

        this.colorIndex();
    },
    watch: {
        searchQuery: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.color_index) {
                this.$store.state.sources.color_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedColorIndex();
        },

        colorToStoreColorImage: function (clr) {
            if(clr !== null) {
                this.colorImageStoreDialog = true;
            }
        },
        colorImageStoreDialog: function (visible) {
            if(!visible) {
                this.resetColorImageForm();
                this.$store.commit("resetValidation");
                this.colorToStoreColorImage = null;
            }
        },
        colorToDeleteColorImage: function (clr) {
            if(clr !== null) {
                this.colorImageDeleteDialog = true;
            }
        },
        colorImageDeleteDialog: function (visible) {
            if(!visible) {
                this.colorToDeleteColorImage = null;
            }
        },
    }
}
</script>
